import state from "./generalState";
import actions from "./generalAction";
import mutations from "./generalMutation";
import getters from "./generalGetter";
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
